<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="hrissecondary"
        class="white--text"
        v-on="on"
      >
        Create Payroll Cycle
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Cycle"
      text="Create payroll cycle"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="payrollCycle"
                v-validate="'required'"
                :error-messages="errors.collect('payrollCycle')"   
                data-vv-name="payrollCycle" 
                data-vv-as="payroll cycle" 
                label="Payroll Cycle"
                :items="payrollCycles"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>  
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          create
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriodId: {
        type: Number,
        default: null,
      },
      existingPayrollCycles: {
        type: Array,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        payrollCycles: [],
        payrollCycle: null,
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.$api.hrisPayrollCycles().list()
          .then(res => {
            this.payrollCycles = _.orderBy(res.data.filter(pc => {
              return !this.existingPayrollCycles.includes(pc.id)
            }), ['name'], ['asc'])
          })
      },
    },

    methods: { 
      prepareFormData () {
        return {
          payroll_cycle_id: this.payrollCycle,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.payrollPeriodCycles().create(this.payrollPeriodId, this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>
